import {Component, Inject, OnInit} from '@angular/core';
import {FormBuilder, FormGroup} from "@angular/forms";
import {Router} from "@angular/router";
import {AlmacenService} from "../../../services/api/almacen.service";
import {FormIngresoService} from "../../../services/forms/form-ingreso.service";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import Swal from "sweetalert2";
import { AventuraService } from 'src/app/services/api/aventura.service';

@Component({
  selector: 'app-dialog-ingreso-equipo',
  templateUrl: './dialog-ingreso-equipo.component.html',
  styleUrls: ['./dialog-ingreso-equipo.component.css']
})
export class DialogIngresoEquipoComponent implements OnInit {

  equipoForm!:FormGroup;
  estado:any;
  equipoId:any;

  selectedEstado: string | null = null;
  arrayEstado: any = ['AVERIADO','DISPONIBLE', 'NO RETORNADO'];

  validationOptions: { value: number, label: string }[] = [
    { value: 1, label: '1 - PESIMO ESTADO' },
    { value: 2, label: '2 - MAL ESTADO' },
    { value: 3, label: '3 - DESGASTADO' },
    { value: 4, label: '4 - BUEN ESTADO' },
    { value: 5, label: '5 - PERFECTO ESTADO' }
  ];

  selectOption(option: number) {
    // console.log('Opción seleccionada:', option);
    this.equipoForm.get('valoracion')?.setValue(option);
  }

  constructor(private router: Router, private fb: FormBuilder, private almacenService:AventuraService ,private formService: FormIngresoService ,
              public dialogRef: MatDialogRef<DialogIngresoEquipoComponent>, @Inject(MAT_DIALOG_DATA) public data:any,
  ) {

  }

  ngOnInit(): void {
    this.equipoForm = this.fb.group({
      equipo: this.formService.getEquipoForm()
    });

    this.equipoForm.get(['equipo','nombre'])?.setValue(this.data.nombre);
    this.equipoForm.get(['equipo','marca'])?.setValue(this.data.marca);
    this.equipoForm.get(['equipo','modelo'])?.setValue(this.data.modelo);
    this.equipoForm.get(['equipo','talla'])?.setValue(this.data.talla);
    this.equipoForm.get(['equipo','categoria'])?.setValue(this.data.categoria);
    this.equipoForm.get(['equipo','costo'])?.setValue(this.data.costo);


    this.equipoForm.get(['equipo','nombre'])?.disable()
    this.equipoForm.get(['equipo','marca'])?.disable()
    this.equipoForm.get(['equipo','modelo'])?.disable()
    this.equipoForm.get(['equipo','talla'])?.disable()
    this.equipoForm.get(['equipo','categoria'])?.disable()
    this.estado=this.data.estado;
    this.equipoId=this.data.id;
    // console.log(this.estado);

  }

  updateEquipo(){
    // console.log("asd: ",this.selectedEstado)
    const equipo={
      nombreEquipo:this.equipoForm.value.equipo.nombre,
      marcaEquipo:this.equipoForm.value.equipo.marca,
      modeloEquipo:this.equipoForm.value.equipo.modelo,
      tallaEquipo:this.equipoForm.value.equipo.talla,
      categoria:this.equipoForm.value.equipo.categoria,
      valoracionEquipo:this.equipoForm.value.valoracion,
      costo:this.equipoForm.value.equipo.costo,
      observacionEquipo:this.equipoForm.value.equipo.observaciones,
      estado:this.selectedEstado,
      fileAsignado:"",
    };

    if(equipo.estado=="NO RETORNADO"){
      equipo.fileAsignado=this.data.fileNumber
    }

    this.almacenService.updateEquipoInventario(this.equipoId,equipo).subscribe(data=>{

      this.almacenService.updateEgresoEquipo(this.data.idEgreso,{estado:"RETORNADO"}).subscribe(res=>{
        Swal.fire({
          position: 'top-end',
          icon: 'success',
          title: 'Se retornó el equipo al almacén',
          showConfirmButton: false,
          timer: 4000
        });

      this.dialogRef.close(1);
      })


    })

  }
  

}
